<template>
	<div id="app">
		<heade></heade>
		<div class="skytop"></div>
		<transition :key="key">
			<router-view></router-view>
		</transition>
		<!--<div class="skyapp"></div>-->
		<foote></foote>
	</div>
</template>

<script>
  import heade from '@/components/head';
  import foote from '@/components/footeNav'
  /*import Vue from 'vue'
      Vue.use(vant);*/

  export default {
    name: "app",
    components:{heade,foote},
	data(){
      return{
        isPc: null,
        isRouterAlive: true
      }
	},
    computed: {
      key() {
        return this.$route.name !== undefined
          ? this.$route.name + new Date()
          : this.$route + new Date();
      },

    },
    watch:{
      isPc(){
        this.$store.state.isPc = this.isPc;
        if(this.isPc){
          if(this.$route.name == 'home'){
            this.$store.state.actcon = 0;
          }else if(this.$route.name == 'news'){
            this.$store.state.actcon = 1;
          }else if(this.$route.name == 'market'){
            this.$store.state.actcon = 2;
          }else if(this.$route.name == 'index'){
            this.$store.state.actcon = 3;
          }else if(this.$route.name == 'exhibiton'){
            this.$store.state.actcon = 4;
          }else if(this.$route.name == 'artist'){
            this.$store.state.actcon = 5;
          }else if(this.$route.name == 'details'){
            this.$store.state.actcon = sessionStorage.getItem('ACTRON');
            console.log(this.$store.state.actcon);
          }else {
            this.$store.state.actcon = -1;
          }
        }
      },
      key(){
        if(this.isPc){
          if(this.$route.name == 'home'){
            this.$store.state.actcon = 0;
          }else if(this.$route.name == 'news'){
            this.$store.state.actcon = 1;
          }else if(this.$route.name == 'market'){
            this.$store.state.actcon = 2;
          }else if(this.$route.name == 'index'){
            this.$store.state.actcon = 3;
          }else if(this.$route.name == 'exhibiton'){
            this.$store.state.actcon = 4;
          }else if(this.$route.name == 'artist'){
            this.$store.state.actcon = 5;
          }else if(this.$route.name == 'details'){
            this.$store.state.actcon = sessionStorage.getItem('ACTRON');
            console.log(this.$store.state.actcon);
          }else {
            this.$store.state.actcon = -1;
          }
        }
      }
    },
	created(){
      // this.$store.state.isPc = this.IsPC();

	},
    mounted() {
      this.isPc = this.IsPC();
      console.log('11111'+this.$store.state.isPc);
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state));
      });
	},
	methods:{
      IsPC(){
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
        }
        return flag;
      }
	}
  };
</script>
<style lang="scss">
	*{
		margin: 0;
		padding: 0;
	}
	@import "./assets/css/index.css";
	@media screen and(min-width: 1025px) {
		.skytop{
			height: 80px;
		}
		.skyapp{
			height: 120px;
		}
	}
	@media screen and(max-width: 1024px) {
		.skytop{
			height: 2.2rem;
		}
		.skyapp{
			height: 9.05rem;
		}
	}

	/* #app {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #2c3e50;
            height:100%;
        }
        body,html{
            font-size:12px;
            height:100%;
        }
        * {
            padding: 0;
            margin: 0;
            max-width:100%;
        }
        input {
            border: none;
            outline: none;

            -webkit-appearance: none;
        }
        ul,
        ol {
            list-style: none;
        }
        .f_left {
            float: left;
        }

        .f_right {
            float: right;
        }
        .clearfix::before,
        .clearfix::after {
            content: "";
            height: 0;
            line-height: 0;
            display: block;
            visibility: hidden;
            clear: both;
        } */
</style>
